/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { createAsyncThunk } from "@reduxjs/toolkit";

import { QrCodeGenerator } from "../../../model/utility/qrcodelib";
import { Log } from "../../../model/logging";
import { QR_BORDER, QR_SCALE } from "../signIn.constants";

const TAG: string = "signIn/qrCodeThunks";

/**
 * Renders the license-plate binding URL as a QR code bitmap for the
 * "Use Code" screen.
 */
export const generateQrCodeBitmap = createAsyncThunk<
  string,
  string,
  { rejectValue: string }
>("signIn/generateQrCodeBitmap", async (url: string, { rejectWithValue }) => {
  try {
    if (url === "") {
      return "";
    }
    const result = QrCodeGenerator.generateQrCode(url, QR_SCALE, QR_BORDER);
    return result.bitmap;
  } catch (error: unknown) {
    Log.e(TAG, "generateQrCodeBitmap()", error);
    if (error instanceof Error) {
      return rejectWithValue(error.message);
    }
    return rejectWithValue("QR code generation failed");
  }
});
